import * as React from "react";
import ConfigUtility from '../../Core/ConfigUtility';
import SmartLookClient from 'smartlook-client'

export interface Props {
    children?: React.ReactNode
}

export interface State {
}

export default class SmartlookErrorMonitor extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {
        ConfigUtility.get().then(x => {
            if (x.SmartLook.Enabled) {

                SmartLookClient.init(x.SmartLook.ProjectKey);
            }
        });
    }

    render() {
        return (
            <>{this.props.children}</>
        )
    }
}
